import type { Layout } from '$lib/types/Components/SharedTypes';

export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 992;

export const DEFAULT_LAYOUT: Layout = {
    isInSingleColumn: false,
    isInColumn: false,
    isInFramedColumn: false,
    isInMultiColumn: false,
    columnCount: 0,
};
